export interface WelcomeContent {
  organizationId: string
  organizationName: string
  description: string | null
  welcomeMessage: string | null
  welcomeVideoUrl: string | null
}

export const ONBOARDING_WELCOME_CONTENT = "/onboarding/welcome-content"
export const ONBOARDING_WELCOME_SEEN = "/onboarding/welcome-seen"
